import { useInfiniteQuery } from '@tanstack/react-query';
import { quoteActivitiesService } from '@/services/quotes/activities';
import type { ListQuoteActivitiesResponse } from '@/services/quotes/activities';

const PAGE_SIZE = 20;

export const quoteActivitiesQueryKey = (policyId: string) => [
  'quote-activities',
  policyId,
];

/**
 * Histórico de atividades da cotação, paginado por cursor do DynamoDB.
 *
 * `enabled` deve refletir o perfil do usuário: o endpoint devolve 403 para
 * corretor, então nem disparamos a request quando o bloco não vai aparecer.
 */
export function useQuoteActivities(
  policyId: string,
  options: { enabled?: boolean } = {}
) {
  return useInfiniteQuery({
    queryKey: quoteActivitiesQueryKey(policyId),
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam }) => {
      const result = await quoteActivitiesService.listActivities(policyId, {
        limit: PAGE_SIZE,
        cursor: pageParam,
      });

      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Não foi possível carregar o histórico de atividades.'
        );
      }

      return result.data;
    },
    getNextPageParam: (lastPage: ListQuoteActivitiesResponse) =>
      lastPage.nextCursor ?? undefined,
    staleTime: 30_000,
    enabled: Boolean(policyId) && options.enabled !== false,
  });
}
